// Recursively decode URL because the user may or may not paste an encoded
// URL...
export default (url) => {
    if (!url) return;
    while(url.search(/%[0-9a-f]{2}/i) > 0) {
        let tmp = url;
        url = decodeURIComponent(url);

        // This isn't necessary but is a safety precaution against an 
        // infinite loop (URL decoding has some nuances that can cause 
        // unexpected behaviour)
        if (tmp === url) {
            console.log("Error decoding URL");
            break;
        }
    }
    return url;
}
